import {
  CatalogCardBreakpoint,
  CatalogColumnsByVariant,
  GetCatalogCardColumnsParams,
} from './catalogCardColumns.types';

const CATALOG_COLUMNS_BY_BREAKPOINT: Record<CatalogCardBreakpoint, CatalogColumnsByVariant[]> = {
  xs: [{ small: 3, medium: 2, large: 1 }],
  sm: [{ small: 4, medium: 3, large: 2 }],
  md: [{ small: 4, medium: 3, large: 2 }],
  lg: [
    { small: 8, medium: 5, large: 3 },
    { small: 8, medium: 5, large: 2 },
    { small: 7, medium: 4, large: 2 },
    { small: 5, medium: 2, large: 1 },
  ],
  xl: [
    { small: 8, medium: 5, large: 3 },
    { small: 8, medium: 5, large: 3 },
    { small: 8, medium: 5, large: 3 },
    { small: 8, medium: 5, large: 2 },
  ],
};

export const getCatalogCardColumns = ({
  breakpoint,
  openPanelsCount,
  variant,
}: GetCatalogCardColumnsParams): number => {
  const columnsByPanelCount = CATALOG_COLUMNS_BY_BREAKPOINT[breakpoint];
  const boundedCount = Math.min(Math.max(openPanelsCount, 0), columnsByPanelCount.length - 1);
  return columnsByPanelCount[boundedCount][variant];
};
